/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicensingModule
 */

import { ClusterItem } from 'items/cluster.item.factory';
import { Injector } from '@angular/core';
import { PortalInfo, PORTAL_INFO_ITEM_TOKEN } from 'ajs/modules/cportal/factories/portal-info.item.factory';
import { TenantItem } from 'ajs/modules/accounts';
import { TENANT_ITEM_TOKEN } from 'ajs/modules/accounts/accounts.tokens';

import {
    AlbServicesSiteItem,
    ALB_SERVICES_SITE_ITEM_TOKEN,
    LicensePoolItem,
    LICENSE_POOL_ITEM_TOKEN,
} from '../items/factories';

const $injector = '$injector';

type TCluster = typeof ClusterItem;
type TPortalInfo = typeof PortalInfo;
type TTenantItem = typeof TenantItem;
type TAlbServicesSiteItem = typeof AlbServicesSiteItem;
type TLicensePoolItem = typeof LicensePoolItem;

export const ClusterProvider = {
    deps: [$injector],
    provide: 'Cluster',
    useFactory(ajsInjector: Injector): TCluster {
        return ajsInjector.get('Cluster');
    },
};

export const PortalInfoProvider = {
    deps: [$injector],
    provide: PORTAL_INFO_ITEM_TOKEN,
    useFactory(ajsInjector: Injector): TPortalInfo {
        return ajsInjector.get(PORTAL_INFO_ITEM_TOKEN);
    },
};

export const TenantItemProvider = {
    deps: [$injector],
    provide: TenantItem,
    useFactory(ajsInjector: Injector): TTenantItem {
        return ajsInjector.get(TENANT_ITEM_TOKEN);
    },
};

export const AlbServicesSiteProvider = {
    deps: [$injector],
    provide: ALB_SERVICES_SITE_ITEM_TOKEN,
    useFactory(ajsInjector: Injector): TAlbServicesSiteItem {
        return ajsInjector.get(ALB_SERVICES_SITE_ITEM_TOKEN);
    },
};

export const LicensePoolProvider = {
    deps: [$injector],
    provide: LICENSE_POOL_ITEM_TOKEN,
    useFactory(ajsInjector: Injector): TLicensePoolItem {
        return ajsInjector.get(LICENSE_POOL_ITEM_TOKEN);
    },
};
